module.exports = __webpack_public_path__ + "static/media/logo.6904c3fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar/icons/logo.svg
// module id = 1669
// module chunks = 0